module.exports = __webpack_public_path__ + "assets/img/Pioneer_Livingstone.9a207d88-ps.jpg";